/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { addHours, format, getYear, parseISO } from 'date-fns';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';

import 'react-credit-cards-2/dist/es/styles-compiled.css';

import Card from 'react-credit-cards-2';

import { buscaCep } from '../../utils/buscaCep';

import getValidationErrors from '../../utils/getValidationErrors';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useCategoria } from '../../hooks/categoria';

import SelectSync, { IOption } from '../SelectSync';
import Input from '../Input';
import InputMoney from '../InputMoney';
import InputFake from '../InputFake';

import {
  formatPrice,
  ORIGEM_PAGAMENTO,
  replaceCaracteres,
  TIPO_USUARIO,
  updateTimeToNow,
  validarCNPJ,
} from '../../utils/funcoes';

import { Container } from './styles';
import api from '../../services/api';

import Loading from '../Loading';
import getResponseErrors from '../../utils/getResponseErrors';
import ControlesNotaFiscal from '../ControlesNotaFiscal';
import CopiarAreaTrabalho from '../CopiarAreaTrabalho';
import { useClinica } from '../../hooks/clinica';
import InputMask from '../InputMask';
import validarCpf from '../../utils/validarCpf';

const INITIAL_STATE = {
  cvc: '',
  cardExpirationMonth: '',
  cardExpirationYear: '',
  cardholderName: '',
  cardNumber: '',
  identificationType: 'CPF',
  parcela: '1',
};

interface IPagamento {
  PagCodigo?: number;
  PagCprCodigo?: number;
  PagFormaPag: number;
  PagData: Date;
  PagValor: number;
  PagExcluido?: boolean;
  PagConferido?: boolean;
  PagCanUsuCodigo?: number;
  PagCanMotCodigo?: number;
  PagCanMotivo?: string;
  formaDePagamento?: IFormaPagamento;
  valorFormatado?: string;
}

type PagamentoProps = {
  cprCodigo?: number;
  tipo: string;
  pacCodigo?: number;
  atualizarCartao?: boolean;
  handleFechar(load: boolean): void;
};
export interface IContaPR {
  CprCodigo?: number;
  CprCodOrigem: number;
  CprOrigem: number;
  CprCatCodigo: number;
  CprDataVenc: Date;
  CprValor: number;
  CprNParcela: number;
  CprFormaPag: number;
  CprDataPag?: Date;
  CprReceita: number;
  CprPago: boolean;
  CprExcluida: boolean;
  CprHistorico: string;
  CprValorPag?: number;
  CprConferido?: boolean;
  CprClinica: number;
  CprDataOrigem?: Date;
  CprParcelaAtiva?: boolean;
  CprUsuCodigo: number;
  CprChave?: string;
  pagamento?: IPagamento[];

  CprDataBaixa?: Date;
  CprDesUsuCodigo?: number;
  CprDesMotCodigo?: number;
  CprDesMotivo?: string;
  created_at?: Date;
  updated_at?: Date;
  DataAtualizacaoAgenda?: string;
  usuarioPagamento?: IUsuarioPagamento;
  // pagamentoAgenda?: IAgenda;
}
interface IUsuarioPagamento {
  UsuCodigo: number;
  UsuLogin: string;
  UsuNome: string;
  UsuSenha: string;
}
interface IFormaPagamento {
  BanCodigo: number;
  BanNome: string;
  BanSaldo?: number;
  BanTipo?: boolean;
  BanAtivo?: boolean;
}

interface IFormProps extends FormHandles {
  CprHistorico: string;
  CprCatCodigo: string;
  CprNParcela: string;
  CprValor: number;
  CprDataVenc: Date;
  CprFormaPag: number;
  CprValorPag: number;
  CprDataPag: Date;
  ChkPago: boolean;
  cardholderName: string;
  cardholderEmail: string;
  identificationNumber: string;
  identificationType: string;
  cvc: string;
  cardExpirationMonth: string;
  cardExpirationYear: string;
  cardNumber: number
  endereco: string;
  numero: string;
  cep: string;
  telefone: string;

}

const ano = getYear(new Date());
const optionsAno = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
  value => {
    return {
      value: String(ano + value).substring(2, 4),
      label: String(ano + value),
    };
  },
);

function validarCpfCnpf(valor: string | undefined): boolean {
  if (!valor) return false
  if (valor.length === 11) return validarCpf(valor)
  if (valor.length === 14) return validarCNPJ(valor)
  return false
}

const PagamentoAssinatura: React.FC<PagamentoProps> = ({
  cprCodigo,
  tipo,
  pacCodigo,
  atualizarCartao,
  handleFechar,
}) => {
  const { user, clinica } = useAuth();
  const { dataHoraServidor } = useClinica();
  const { optionCategorias, buscaCategoria } = useCategoria();

  const [contaPRSelecionada, setContaPRSelecionada] = useState<
    IContaPR | undefined
  >(undefined);

  const [pagamentosRealizados, setPagamentosRealizados] = useState<
    IPagamento[]
  >([]);

  const [state, setState] = useState(INITIAL_STATE);

  const [dadosBaixa, setDadosBaixa] = useState<
    { nome?: string; data?: string; alteracao?: string } | undefined
  >(undefined);

  const [loading, setLoading] = useState(false);
  const [mensagemPermissaoAdmin, setMensagemPermissaoAdmin] = useState('');
  const [nomeCategoria, setNomeCategoria] = useState('');
  const [loadingCep, setLoadingCep] = useState(false);
  const [ip, setIp] = useState<string>('');

  const formRefPagamento = useRef<IFormProps>(null);

  const { addToast } = useToast();

  const [optionsCategoria, setOptionsCategoria] = useState<IOption[]>([]);

  const ehCartaoSaude = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.CARTAO;
  }, [tipo]);

  const ehTelemedicina = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.TELEMEDICINA;
  }, [tipo]);

  const ehNovo = useMemo(() => {
    return !cprCodigo;
  }, [cprCodigo]);

  useEffect(() => {
    async function pegaIp(): Promise<void> {
      try {
        const response = await fetch('https://api64.ipify.org');
        const data = await response.text();
        setIp(data);
      } catch (error) {
        setIp('10.1.1.1');
        console.log('não foi possível identificar o IP');
      }
    }
    pegaIp();
  }, []);

  useEffect(() => {
    if (!optionCategorias || Object.keys(optionCategorias).length === 0)
      buscaCategoria();
  }, [buscaCategoria, optionCategorias]);

  useEffect(() => {
    async function loadOptionsCategoria(): Promise<void> {
      try {
        setOptionsCategoria(optionCategorias.receita);
      } catch (error) {
        handleFechar(false);
        addToast({
          title: 'Não foi possível buscar categorias',
          type: 'error',
        });
      }
    }
    if (ehCartaoSaude || ehTelemedicina) {
      loadOptionsCategoria();
    }

  }, [tipo, addToast, ehCartaoSaude, ehTelemedicina, handleFechar, optionCategorias]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);

      let contaPrSelecionada: any;
      try {

        const response = await api.get<IContaPR>(
          `/pagamento/${cprCodigo}?CprCodOrigem=${0}`,
        );

        contaPrSelecionada = response.data;
        setContaPRSelecionada(contaPrSelecionada);

        const nome = contaPrSelecionada.usuarioPagamento?.UsuNome;
        const data = contaPrSelecionada.CprDataBaixa
          ? format(
            parseISO(contaPrSelecionada.CprDataBaixa.toString()),
            'dd/MM/yyyy HH:mm',
          )
          : undefined;

        const alteracao = contaPrSelecionada.updated_at
          ? format(
            addHours(parseISO(contaPrSelecionada.updated_at.toString()), -3),
            'dd/MM/yyyy HH:mm',
          )
          : undefined;

        setDadosBaixa({ nome, data, alteracao });
        const pagamentos: IPagamento[] = contaPrSelecionada.pagamento
          ?.filter((pag: any) => pag.PagExcluido === false)
          .map((pag: any) => {
            return {
              ...pag,
              valorFormatado: formatPrice(pag.PagValor),
            };
          });

        if (pagamentos && pagamentos.length > 0)
          setPagamentosRealizados(pagamentos);
        const categ = optionsCategoria.find(
          cat => cat.value === contaPrSelecionada.CprCatCodigo.toString(),
        );

        if (categ) setNomeCategoria(categ.label);
        formRefPagamento.current?.setData({
          ...contaPrSelecionada,
          CprCatCodigo: contaPrSelecionada.CprCatCodigo.toString(),
          CprFormaPag: contaPrSelecionada.CprFormaPag.toString(),
          CprDataVenc: format(
            parseISO(contaPrSelecionada.CprDataVenc.toString()),
            'yyyy-MM-dd',
          ),
          CprDataPag: contaPrSelecionada.CprDataPag
            ? format(
              parseISO(contaPrSelecionada.CprDataPag.toString()),
              'yyyy-MM-dd',
            )
            : format(
              updateTimeToNow(new Date(dataHoraServidor.toString())),
              'yyyy-MM-dd',
            ),
          cardholderName: '',
          cardholderEmail: '',
          identificationNumber: '',
          identificationType: '',
          cvc: '',
          cardExpirationMonth: '',
          cardExpirationYear: '',
          cardNumber: '',
          endereco: '',
          numero: '',
          cep: '',
          telefone: '',
        });


      } catch (error) {
        handleFechar(false);
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar registro de pagamento',
          type: 'error',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
    if (!ehNovo && optionsCategoria && optionsCategoria.length > 0) loadDados();
  }, [
    ehNovo,
    addToast,
    cprCodigo,
    optionsCategoria,
    setLoading,
    handleFechar,
    tipo,
    pacCodigo,
    dataHoraServidor,
  ]);

  const estaPago = useMemo(() => {
    return contaPRSelecionada?.CprPago;
  }, [contaPRSelecionada?.CprPago]);


  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleBuscaCepApi = useCallback(
    async (value: string) => {
      const cep = replaceCaracteres(value);
      if (cep.length !== 8) return;

      setLoadingCep(true);

      const retornoCep = await buscaCep(cep);

      // if (retornoCep.erro) {
      //   setError('cep', {
      //     type: 'custom',
      //     message: 'CEP inválido',
      //   });
      //   return;
      // }

      const { logradouro } = retornoCep;
      const dados = formRefPagamento.current?.getData();
      formRefPagamento.current?.setData({ ...dados, 'endereco': logradouro });
      // setFocus('numero');
      setLoadingCep(false);
    },
    [],
  );


  const validaDados = useCallback(async (dadosForm): Promise<boolean> => {
    try {
      formRefPagamento.current?.setErrors({});

      const schemaPadrao = Yup.object().shape({
        cardholderName: Yup
          .string()
          .min(10, 'Mínimo de 10 caracteres')
          .required('Nome é obrigatório'),
        cardholderEmail: Yup.string()
          .required('E-mail obrigatório')
          .email('Digite um e-mail válido'),
        identificationNumber: Yup
          .string()
          .min(11, 'Mínimo 11 caracteres')
          .required('Número do documento é obrigatório')
          .test('test-invalid-cpf', 'Documento inválido', (doc) =>
            validarCpfCnpf(doc),
          ),
        identificationType: Yup.string().required('Tipo é obrigatório'),
        cvc: Yup
          .string()
          .min(1, 'CVV Inválido')
          .max(9999, 'CVV Inválido')
          .typeError('Campo obrigatório, digite apenas números')
          .required(),
        cardExpirationMonth: Yup
          .string()
          .min(1, 'Mês deve ser entre 01 e 12')
          .max(12, 'Mês deve ser entre 01 e 12')
          .typeError('Campo obrigatório, digite apenas números')
          .required(),
        cardExpirationYear: Yup
          .string()
          .max(99)
          .typeError('Campo obrigatório, digite apenas números')
          .required()
          .test('select', 'Selecione um item', (value) => value !== '0'),
        cardNumber: Yup
          .number()
          .typeError('Campo obrigatório,minimo 16 dígitos')
          .required(),
        endereco: Yup
          .string()
          .min(5, 'Mínimo 5 caracteres')
          .required('Endereço é obrigatório'),
        numero: Yup.string().required('Campo obrigatório'),
        cep: Yup
          .string()
          .required('CEP é obrigatório')
          .test('test-invalid-cep', 'Mínimo 8 dígitos', (cep) => {
            if (!cep) return false
            const numsStr = replaceCaracteres(cep)
            return numsStr.length === 8
          }),
        telefone: Yup
          .string()
          .min(10, 'Mínimo 10 dígitos')
          .min(11, 'Mínimo 11 dígitos')
          .test('test-invalid-Tel', 'Mínimo 10 dígitos', (tel) => {
            if (!tel) return false
            const numsStr = replaceCaracteres(tel)
            return numsStr.length >= 10
          })
          .required('Telefone é obrigatório'),

      })

      await schemaPadrao.validate(dadosForm, {
        abortEarly: false,
      });
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefPagamento.current?.setErrors(errors);
      }
      return false;
    }
  }, []);



  const handleSubmit = useCallback(
    async (dados: IFormProps) => {
      formRefPagamento.current?.setErrors({});

      if (!contaPRSelecionada) {
        addToast({
          type: 'error',
          title: 'Nenhum registro selecionado',
        });
        return;
      }

      if (formRefPagamento.current) {
        const {
          CprDataVenc,
          cardholderName,
          cardholderEmail,
          identificationNumber,
          identificationType,
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardNumber,
          endereco,
          numero,
          cep,
          telefone,
        } = formRefPagamento.current.getData();



        setLoading(true);

        const dadosForm = {
          cardholderName,
          cardholderEmail,
          identificationNumber,
          identificationType,
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardNumber,
          endereco,
          numero,
          cep,
          telefone,
        };

        const validado = await validaDados(dadosForm);

        if (!validado) {

          setLoading(false);
          return;
        }

        const dadosFormatados = {
          remoteIp: ip,
          payment_method_id: 'credit_card',
          transaction_amount: contaPRSelecionada.CprValor.toString(),
          installmentCount: 1,
          installmentValue: contaPRSelecionada.CprValor.toString(),
          external_reference: `${ehCartaoSaude ? 'PLANO_' : 'TELE_'}${contaPRSelecionada.CprCodOrigem.toString()}`,
          description: contaPRSelecionada?.CprHistorico,
          payer: {
            name: cardholderName,
            email: cardholderEmail,
            identification: {
              type: identificationType,
              number: identificationNumber,
            },
          },
          creditCard: {
            holderName: cardholderName,
            number: replaceCaracteres(cardNumber.toString()),
            expiryMonth: cardExpirationMonth.toString(),
            expiryYear: cardExpirationYear,
            ccv: cvc.toString(),
          },
          creditCardHolderInfo: {
            name: cardholderName,
            email: cardholderEmail,
            cpfCnpj: replaceCaracteres(identificationNumber),
            postalCode: replaceCaracteres(cep),
            addressNumber: numero,
            phone: replaceCaracteres(telefone),
          },
          atualizarCartao: atualizarCartao || false,
        };


        try {


          await api.post(
            `/caixa/confirmaPagamentoAssinatura/${contaPRSelecionada.CprChave}`,
            dadosFormatados,
          );

          addToast({
            type: 'success',
            title: 'Salvo com sucesso',
          });
          handleFechar(true);
        } catch (error: any) {
          const mensagemErro = getResponseErrors(error);
          const statusErro = error?.response?.status;
          if (statusErro === 403) {
            // setExibePermissaoAdmin(true);
            setMensagemPermissaoAdmin(mensagemErro);
          }
          addToast({
            type: 'error',
            title: 'Erro ao salvar pagamento',
            description: mensagemErro,
          });
        }
        setLoading(false);
      }
    }, [
    ip,
    addToast,
    validaDados,
    handleFechar,
    contaPRSelecionada,
    setLoading,
    dataHoraServidor,
    atualizarCartao,
    ehCartaoSaude,
  ]);


  const handleOnChangeInput = useCallback(
    (year: string | undefined) => {
      const dados = formRefPagamento.current?.getData();

      if (dados) {
        const {
          cvc,
          cardExpirationMonth,
          cardExpirationYear,
          cardholderName,
          cardNumber,
          identificationType,
          parcela,
        } = dados;
        setState({
          cvc: cvc.toString(),
          cardExpirationMonth: cardExpirationMonth.toString(),
          cardExpirationYear: year || cardExpirationYear.toString(),
          cardholderName,
          cardNumber: cardNumber.toString(),
          identificationType,
          parcela,
        });
      }
    },
    [],
  );

  return (
    <>
      <Container>
        {loading && <Loading backgroundBlack={false} />}
        <Row className={`no-gutters `}>
          <Col md="12" lg="12" className="form-group pr-2">
            <Card
              cvc={state.cvc}
              expiry={state.cardExpirationMonth + state.cardExpirationYear}
              name={state.cardholderName}
              number={state.cardNumber}
            />
          </Col>
        </Row>
        <Form
          ref={formRefPagamento}
          // initialData={{ CprValorPag: '' }}
          onSubmit={handleSubmit}

        >
          <Row noGutters>
            <Col md="12" lg="12" className="form-group pr-2">
              <Input
                name="CprHistorico"
                label="Histórico"
                disabled
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col
              md="4"
              lg="4"
              style={{ zIndex: 4 }}
              className={`form-group pr-2 ${ehNovo ? '' : 'd-none'
                }`}
            >
              <SelectSync
                name="CprCatCodigo"
                label="Categoria"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                options={optionsCategoria || { label: '', value: '' }}
              />
            </Col>
            <Col
              md="4"
              lg="4"
              className={`form-group pr-2 ${ehNovo ? 'd-none' : ''
                }`}
            >
              <InputFake label="Categoria" disabled value={nomeCategoria} />
            </Col>
            <Col md="2" lg="2" className="form-group pr-2">
              <Input name="CprNParcela" label="Parcela" disabled />
            </Col>
            <Col md="3" lg="3" className="form-group pr-2">
              <InputMoney
                label="Valor"
                name="CprValor"
                autoComplete="nope"
                placeholder="Valor"
                disabled={!ehNovo}
              />
            </Col>
            <Col md="3" lg="3" className="form-group pr-2">
              <Input
                label="Vencimento"
                name="CprDataVenc"
                type="date"
                disabled
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col md="4" lg="4" className="form-group pr-2">
              <InputMask
                name="cardNumber"
                label="Número do Cartão"
                placeholder="1234 0000 0000 0000"
                mask="9999 9999 9999 9999"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardNumber', '');
                }}
                onChange={(data: any) => {

                  handleOnChangeInput(undefined);
                }}
              />
            </Col>
            <Col md="8" lg="8" className="form-group pr-2">
              <Input
                label="Nome"
                name="cardholderName"
                placeholder="Igual ao escrito no cartão"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardholderName', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="cardExpirationMonth"
                label="Mês"
                placeholder="00"
                type="number"
                min="1"
                max="12"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardExpirationMonth', '');
                }}
                onChange={(data: any) => {

                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="3" lg="3" className="form-group pr-2">
              <SelectSync
                name="cardExpirationYear"
                label="Ano"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                options={optionsAno || { label: '', value: '' }}
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cardExpirationYear', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="cvc"
                label="CVC"
                placeholder="000"
                type="number"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('cvc', '');
                }}
                onChange={(data: any) => {
                  handleOnChangeInput(undefined);
                }}
              />
            </Col>

            <Col md="5" lg="5" className="form-group pr-2">
              <InputMask
                name="telefone"
                label="Telefone"
                mask="(99) 99999-9999"
                placeholder="(00) 00000-0000"
              />

            </Col>
          </Row>
          <Row noGutters>
            <Col md="3" lg="3" className="form-group pr-2">
              <SelectSync
                name="identificationType"
                label="Documento"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('identificationType', '');
                }}
                options={[
                  { label: 'CPF', value: 'CPF' },
                  { label: 'CNPJ', value: 'CNPJ' },
                ]}
              />

            </Col>

            <Col md="3" lg="3" className="form-group pr-2">
              <Input
                name="identificationNumber"
                label="Nº Documento"
                onFocus={(data: any) => {
                  formRefPagamento.current?.setFieldError('identificationNumber', '');
                }}
              />
            </Col>

            <Col md="6" lg="6" className="form-group pr-2">
              <Input
                name="cardholderEmail"
                label="E-mail"
                placeholder="E-mail"
              />
            </Col>


          </Row>

          <Row noGutters>
            <Col md="2" lg="2" className="form-group pr-2">
              <InputMask
                name="cep"
                label={loadingCep ? 'Buscando...' : 'CEP'}
                mask="99.999-999"
                placeholder="00.000-000"
                onBlur={(data: any) => {
                  handleBuscaCepApi(data.target.value);
                }}
              />

            </Col>

            <Col md="8" lg="8" className="form-group pr-2">
              <Input
                name="endereco"
                label="Endereço"
                placeholder="Endereço"
              />
            </Col>

            <Col md="2" lg="2" className="form-group pr-2">
              <Input
                name="numero"
                label="Nº do endereço"
                placeholder="Número"
              />
            </Col>
          </Row>





          <Row className="align-items-center border-top p-1">
            <Col md="12">
              <Container
                className={`light-grey text-left pt-3 ${user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA ? 'd-none' : ''
                  }`}
              >
                <>
                  <Button
                    type="submit"
                    variant="success"
                    style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                    size="sm"
                    className={
                      !estaPago && !ehNovo
                        ? 'btn btn-sm btn-success mx-2'
                        : 'd-none'
                    }
                  >
                    Confirmar Pagamento
                  </Button>

                  {cprCodigo &&
                    estaPago &&
                    ehCartaoSaude &&
                    clinica.CliEmiteNFCartao && (
                      <ControlesNotaFiscal cprCodigo={cprCodigo} />
                    )}
                </>
              </Container>
            </Col>
          </Row>
        </Form>
        <Row className="align-items-center p-1">
          <Col md="12">
            <Container
              className={`light-grey text-left pt-3 ${contaPRSelecionada?.CprChave &&
                !contaPRSelecionada?.CprPago &&
                clinica.ConfigBoleto?.EmiteOnLine &&
                process.env.REACT_APP_URL_SITE &&
                contaPRSelecionada?.CprValor >= 5
                ? ''
                : 'd-none'
                }`}
            >
              <CopiarAreaTrabalho
                texto={`${process.env.REACT_APP_URL_SITE}/cartao/pagamentoAssinatura/${contaPRSelecionada?.CprChave}`}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PagamentoAssinatura;
